/* Aromante · Carrusel de perfumes (home): pestañas, flechas y agregar al carrito */
(function () {
  if (customElements.get('aro-scroller')) return;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AroScroller extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ps-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-ps-panel]'));
      this.prev = this.querySelector('[data-ps-prev]');
      this.next = this.querySelector('[data-ps-next]');
      this.liveEl = this.querySelector('[data-ps-live]');
      this.current = 0;

      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.ticking = false; this.updateArrows(); });
      };
      this.panels.forEach((panel) => {
        const track = panel.querySelector('[data-ps-track]');
        if (track) track.addEventListener('scroll', this.onScroll, { passive: true });
      });
      window.addEventListener('resize', this.onScroll);

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(n);
          this.tabs[n].focus();
        });
      });

      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-ps-add]');
        if (btn && this.contains(btn)) { e.preventDefault(); this.add(btn); }
      });

      /* Editor de temas: mostrar la pestaña del bloque seleccionado */
      this.onBlockSelect = (e) => {
        const i = this.tabs.findIndex((t) => t.hasAttribute('data-shopify-editor-block') && JSON.parse(t.getAttribute('data-shopify-editor-block') || '{}').id === e.detail.blockId);
        if (i > -1) this.select(i);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.updateArrows();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    track() {
      const panel = this.panels[this.current];
      return panel ? panel.querySelector('[data-ps-track]') : null;
    }

    select(i) {
      if (i === this.current || !this.panels[i]) return;
      this.current = i;
      this.tabs.forEach((t, n) => {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        t.tabIndex = n === i ? 0 : -1;
      });
      this.panels.forEach((p, n) => { p.hidden = n !== i; });
      const tr = this.track();
      if (tr) tr.scrollLeft = 0;
      this.updateArrows();
    }

    step(track) {
      const card = track.querySelector('.aro-ps__card');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const perView = Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap)));
      return perView * (card.offsetWidth + gap);
    }

    go(dir) {
      const tr = this.track();
      if (!tr) return;
      tr.scrollBy({ left: dir * this.step(tr), behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    updateArrows() {
      const tr = this.track();
      if (!tr || !this.prev || !this.next) return;
      const max = tr.scrollWidth - tr.clientWidth;
      this.classList.toggle('is-static', max <= 2);
      this.prev.disabled = tr.scrollLeft <= 2;
      this.next.disabled = tr.scrollLeft >= max - 2;
    }

    async add(btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.classList.remove('is-added', 'is-error');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.psAdd), quantity: 1 }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
        btn.classList.add('is-added');
        this.say((btn.dataset.name || 'Perfume') + ' se agregó al carrito');
        document.dispatchEvent(new CustomEvent('aro:cart-added', { detail: data }));
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        this.updateBubble();
        setTimeout(() => btn.classList.remove('is-added'), 1800);
      } catch (err) {
        btn.classList.add('is-error');
        this.say(err.message);
        setTimeout(() => btn.classList.remove('is-error'), 1200);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }

    async updateBubble() {
      try {
        const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => { el.textContent = cart.item_count; });
      } catch (e) {}
    }

    say(msg) {
      if (!this.liveEl) return;
      this.liveEl.textContent = '';
      setTimeout(() => { this.liveEl.textContent = msg; }, 60);
    }
  }

  customElements.define('aro-scroller', AroScroller);
})();
